import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { MixedCompositeId } from 'interfaces/linkage'
import { FC, useMemo } from 'react'
import { createActiveAccountBalanceCidsOfProviderSelector } from 'components/features/pageFilters/pageFilterSelectors'
import styles from 'components/features/pageFilters/ProviderGroupItem/ProviderGroupItem.styl'
import { AccountItem } from 'components/features/pageFilters/AccountItem/AccountItem'
import { createProviderSelector } from 'selectors/linkageSelectors'
import cn from 'classnames'

type ProviderGroupItemProps = {
  cid: MixedCompositeId
  className?: string
}
export const ProviderGroupItem: FC<ProviderGroupItemProps> = (props) => {
  const { className } = props

  const providerSelector = useMemo(createProviderSelector, [])
  const provider = useStoreSelector((state) => providerSelector(state, props))

  const pbaCidsSelector = useMemo(createActiveAccountBalanceCidsOfProviderSelector, [])
  const pbaCids = useStoreSelector((state) => pbaCidsSelector(state, props))

  const balancesChild = useMemo(() => {
    return pbaCids.map((pbaCid) => (
      <AccountItem
        key={ pbaCid }
        pbaCid={ pbaCid }
      />
    ))
  }, [pbaCids])

  if (!provider || pbaCids.length === 0) {
    return null
  }

  return (
    <ProviderGroupItemComponent
      title={ provider.name }
      logoUrl={ provider.logo }
      className={ className }
    >
      { balancesChild }
    </ProviderGroupItemComponent>
  )
}

type ProviderGroupItemComponentProps = {
  title: string
  logoUrl?: string
  className?: string
}
export const ProviderGroupItemComponent: FC<ProviderGroupItemComponentProps> = (props) => {
  const { className, title, logoUrl, children } = props

  return (
    <div className={ cn(styles.group, className) }>
      <div className={ styles.header }>
        { logoUrl && <img src={ logoUrl } className={ styles.logo } /> }
        <div className={ styles.label }>
          { title }
        </div>
      </div>
      { children }
    </div>
  )
}
